import Header from "../components/Header";
import Footer from "../components/Footer";

// import "./AuditAssurance.css";

export default function AuditAssurance() {
  return (
    <>
      <Header />

      {/* ===== HERO SECTION ===== */}
      <section className="audit-banner">
        <div className="banner-overlay">
          <div className="banner-content">
            <h1>Audit & Assurance Services</h1>
            <p>
              Providing clarity, confidence, and compliance through accurate
              financial insights and independent assurance.
            </p>
          </div>
        </div>
      </section>

      {/* ===== INTRODUCTION ===== */}
      <section className="audit-intro container my-5">
        <h2>Delivering Trust & Transparency</h2>
        <p className="service-text">
          We provide independent and reliable audit and assurance services that
          ensure compliance, transparency, and improved financial governance.
          Our goal is to help organizations build stakeholder confidence through
          accurate financial reporting and strong internal controls.
        </p>
      </section>

      <section className="audit-process container my-5">
        <h2>Our Audit Process</h2>

        <div className="process-wrapper">
          <img
            src="/assets/img/audit01.png"
            alt="Audit Process"
            className="audit-process-img"
          />
        </div>
      </section>

      {/* ===== SERVICE OFFERINGS ===== */}
      <section className="audit-services container my-5">
        <h2 className="text-center mb-5">Our CMA & Finance Services</h2>
      </section>
      <section className="container bf-main my-5">
        {/* CARD 1 */}
        <div className="bf-card">
          <h3>📋 Statutory Audit</h3>
          <p>
            Audit of financial statements in accordance with the Companies Act
            and ICAI Standards. We ensure your financial statements are
            accurate, compliant, and provide a true and fair view of your
            company's financial position.
          </p>
          <ul>
            <li>Companies Act compliance</li>
            <li>ICAI Standards adherence</li>
            <li>Comprehensive financial statement audit</li>
            <li>Regulatory reporting support</li>
          </ul>
        </div>

        {/* CARD 2 */}
        <div className="bf-card">
          <h3>📊 Tax Audit</h3>
          <p>
            Tax audits under the Income-tax Act, including comprehensive
            reporting and documentation support to ensure compliance with tax
            regulations and optimize your tax position.
          </p>
          <ul>
            <li>Income-tax Act compliance</li>
            <li>Detailed reporting and documentation</li>
            <li>Tax optimization guidance</li>
            <li>Regulatory filing support</li>
          </ul>
        </div>

        {/* CARD 3 */}
        <div className="bf-card">
          <h3>🔍 Internal Audit</h3>
          <p>
            Risk-based internal audits focused on process improvement, controls,
            and compliance. Our independent evaluation helps enhance operational
            efficiency and strengthen your internal control framework.
          </p>
          <ul>
            <li>Risk-based audit approach</li>
            <li>Process improvement recommendations</li>
            <li>Internal controls assessment</li>
            <li>Compliance monitoring</li>
          </ul>
        </div>

        {/* CARD 4 */}
        <div className="bf-card">
          <h3>⚡ Concurrent / Process Audit</h3>
          <p>
            Ongoing reviews for transaction-heavy environments to improve
            accuracy and control. Real-time monitoring and evaluation of
            processes to ensure operational efficiency and compliance.
          </p>
          <ul>
            <li>Real-time process monitoring</li>
            <li>Transaction accuracy verification</li>
            <li>Control enhancement</li>
            <li>Ongoing assessment</li>
          </ul>
        </div>

        {/* CARD 5 */}
        <div className="bf-card">
          <h3>📦 Stock & Inventory Audit</h3>
          <p>
            Verification and reporting for inventory controls, valuation, and
            operational reliability. Ensure your inventory is accurately
            recorded and valued according to accounting standards.
          </p>
          <ul>
            <li>Inventory verification</li>
            <li>Valuation compliance</li>
            <li>Control system assessment</li>
            <li>Operational reliability review</li>
          </ul>
        </div>

        {/* CARD 6 */}
        <div className="bf-card">
          <h3>💼 Due Diligence & Assurance Reviews</h3>
          <p>
            Financial and compliance reviews for investments, acquisitions, and
            strategic transactions. Comprehensive analysis to support informed
            decision-making in critical business transactions.
          </p>
          <ul>
            <li>Financial due diligence</li>
            <li>Compliance review</li>
            <li>Investment analysis</li>
            <li>Transaction support</li>
          </ul>
        </div>

        {/* CARD 7 */}
        <div className="bf-card">
          <h3>✅ Certification & Attestation</h3>
          <p>
            Certificates and assurance reports as required by banks, regulators,
            and authorities. Professional certification services to meet various
            regulatory and institutional requirements.
          </p>
          <ul>
            <li>Bank requirement certificates</li>
            <li>Regulatory attestation</li>
            <li>Authority compliance reports</li>
            <li>Professional certification</li>
          </ul>
        </div>
      </section>

      {/* ===== AUDIT METHODOLOGY ===== */}
      {/* <section className="audit-method my-5">
        <div className="container">
          <h2>Our Audit Methodology</h2>
          <div className="method-grid">
            <div className="method-step">
              <span className="step-number">1</span>
              <h4>Planning</h4>
              <p>
                Understanding your business, defining scope, identifying risks,
                and creating a customized audit plan.
              </p>
            </div>
            <div className="method-step">
              <span className="step-number">2</span>
              <h4>Fieldwork</h4>
              <p>
                Executing audit procedures, testing controls, and gathering
                relevant evidence.
              </p>
            </div>
            <div className="method-step">
              <span className="step-number">3</span>
              <h4>Reporting</h4>
              <p>
                Delivering detailed reports with findings, analysis, and
                recommendations for improvement.
              </p>
            </div>
            <div className="method-step">
              <span className="step-number">4</span>
              <h4>Follow-Up</h4>
              <p>
                Supporting you in implementing audit recommendations and
                ensuring long-term success.
              </p>
            </div>
          </div>
        </div>
      </section> */}

      {/* ===== WHY CHOOSE US ===== */}

      {/* <section className="nri-highlight my-5">
        <div className="container">
          <div className="why-text">
            <h2>Why Choose Us?</h2>
            <ul>
              <li>
                <strong>Expertise & Experience:</strong> A skilled team using a
                risk-based audit approach aligned with the latest regulatory
                updates.
              </li>
              <li>
                <strong>Beyond Compliance:</strong> We deliver actionable
                insights, not just checklists.
              </li>
              <li>
                <strong>Tailored Solutions:</strong> Scalable services suited
                for startups, SMEs, and large organizations.
              </li>
            </ul>
          </div>
        </div>
      </section> */}

      {/* ===== BENEFITS ===== */}
      {/* <section className="audit-benefits container my-5">
        <h2>Key Benefits for Your Business</h2>
        <div className="benefits-grid">
          <div className="benefit-item">✔ Enhanced financial credibility</div>
          <div className="benefit-item">✔ Stronger internal control systems</div>
          <div className="benefit-item">✔ Risk reduction & fraud prevention</div>
          <div className="benefit-item">✔ Process efficiency improvements</div>
          <div className="benefit-item">✔ Better governance & compliance</div>
        </div>
      </section> */}

      {/* <section className="bf-cta py-5 text-white text-center my-5">
  <div className="container">
    <h2 className="fw-bold mb-3"> Let’s Get Started</h2>
    <p className="mb-3">
      Turn your audit process into a strategic advantage. Contact us today
      for a personalized consultation tailored to your business.
    </p>

    <Link
      to="/contactus"
      className="apply-btn"
      style={{
        backgroundColor: "#65ad4b",
        color: "#fff",
        borderRadius: "8px",
      }}
      onClick={() => window.scrollTo({ top: 0 })}
    >
      Contact Us
    </Link>
  </div>
</section> */}

      <Footer />
    </>
  );
}
